import types from './mutationTypes';

export default {
  [types.SET_GAME_STATE](state, gameState) {
    state.gameState = gameState;
  },
  [types.SET_CONFIG](state, config) {
    state.config = config;
  },
  [types.SET_DELIVERY_PLATFORM](state, deliveryPlatform) {
    state.deliveryPlatform = deliveryPlatform;
  },
  [types.SET_SELECTED_NUMBERS](state, selectedNumbers) {
    state.selectedNumbers = selectedNumbers;
  },
  [types.SET_QUICKPICK_NUMBERS_ITEM](state, item) {
    state.quickpickNumbersItem = item;
  },
  [types.SET_QUICKPICK_SYSTEMS_ITEM](state, item) {
    state.quickpickSystemsItem = item;
  },
  [types.SET_ODDS](state, odds) {
    state.odds = odds;
  },
  [types.SET_PAYTABLE](state, paytable) {
    state.paytable = paytable;
  },
  [types.SET_SUGGESTED_SYSTEMS](state, suggestedSystems) {
    state.suggestedSystems = suggestedSystems;
  },
  [types.SET_CURRENT_BET_TYPE](state, currentBetType) {
    state.currentBetType = {
      ...state.currentBetType,
      ...{
        system: null,
        name: null,
        value: null,
        type: null,
        outcome: null,
        odd: null,
      },
      ...currentBetType,
    };
  },
  [types.SET_IS_NO_DRAW_AUTO](state, isNoDrawAuto) {
    state.isNoDrawAuto = isNoDrawAuto;
  },
  [types.SET_CURRENT_SPECIAL_BET](state, currentSpecialBet) {
    state.currentSpecialBet = currentSpecialBet;
  },
  [types.SET_IS_GAME_INFO_OPEN](state, isGameInfoOpen) {
    state.isGameInfoOpen = isGameInfoOpen;
  },
  [types.SET_STATISTICS](state, statistics) {
    state.statistics = statistics;
  },
  [types.SET_IS_STATISTICS_LOADING](state, isStatisticsLoading) {
    state.isStatisticsLoading = isStatisticsLoading;
  },
  [types.SET_RESULTS](state, results) {
    state.results = results;
  },
  [types.SET_IS_RESULTS_LOADING](state, isResultsLoading) {
    state.isResultsLoading = isResultsLoading;
  },
  [types.SET_IS_SETTINGS_OPEN](state, isSettingsOpen) {
    state.isSettingsOpen = isSettingsOpen;
  },
  [types.SET_IS_PAYIN_IN_PROCESS](state, isPayinInProcess) {
    state.isPayinInProcess = isPayinInProcess;
  },
  [types.SET_IS_BETSLIP_OPEN](state, isBetslipOpen) {
    state.isBetslipOpen = isBetslipOpen;
  },
  [types.SET_IS_TICKET_HISTORY_OPEN](state, isTicketHistoryOpen) {
    state.isTicketHistoryOpen = isTicketHistoryOpen;
  },
  [types.SET_IS_CANCEL_MESSAGE_OPEN](state, isCancelMessageOpen) {
    state.isCancelMessageOpen = isCancelMessageOpen;
  },
  [types.SET_CANCEL_MESSAGE](state, cancelMessage) {
    state.cancelMessage = cancelMessage;
  },
  [types.CLEAR_CANCEL_MESSAGE](state) {
    state.cancelMessage = null;
  },
  [types.SET_USER_UUID](state, userUuid) {
    state.userUuid = userUuid;
  },
  [types.SET_LAST_SYSTEM_SELECTION](state, lastSystem) {
    state.lastSystemSelection = lastSystem;
  },
  [types.TOGGLE_NO_DRAW](state) {
    state.isNoDraw = !state.isNoDraw;
  },
  [types.SET_NO_DRAW](state, isActive) {
    state.isNoDraw = isActive;
  },
  [types.TOGGLE_ALL_IN](state) {
    state.isAllIn = !state.isAllIn;
  },
  [types.SET_CHECK_TICKET_TIMEOUT_ID](state, checkTicketTimeoutId) {
    state.checkTicketTimeoutId = checkTicketTimeoutId;
  },
  [types.SET_VISUALIZATION_STATE](state, visualizationState) {
    state.visualizationState = visualizationState;
  },
  [types.SET_JACKPOT_STATE](state, jackpotState) {
    state.jackpotState = jackpotState;
  },
  [types.SET_LAYOUT](state, layout) {
    state.layout = layout;
  },
  [types.SET_TERMINAL_USER_DATA](state, terminalUserData) {
    state.terminalUserData = terminalUserData;
  },
  [types.SET_TERMINAL_TICKETS_HISTORY](state, ticketsHistory) {
    state.terminalTicketsHistory = ticketsHistory;
  },
  [types.SET_TERMINAL_TICKET_DETAILS](state, ticketDetails) {
    state.terminalTicketDetails = ticketDetails;
  },
  [types.SET_NEXT_ROUND_DATE](state, date) {
    state.nextRoundDate = date;
  },
  [types.SET_TICKET_TO_REBET](state, ticketToRebet) {
    state.ticketToRebet = ticketToRebet;
  },
  [types.SET_ACTIVE_COMPONENT](state, activeComponent) {
    state.activeComponent = activeComponent;
  },
  [types.SET_BETTING_DISABLED](state, bettingDisabled) {
    state.bettingDisabled = bettingDisabled;
  },
  [types.TOGGLE_FREE_BET_MODAL](state, show) {
    state.showFreeBetModal = show;
  },
  [types.TOGGLE_FREE_BET_EXPIRED_MODAL](state, show) {
    state.showFreeBetExpiredModal = show;
  },
  [types.SET_VISUALIZATION_LOADED](state, isLoaded) {
    state.isVisualizationLoaded = isLoaded;
  },
  [types.SET_DRAWN_BALL](state, ball) {
    state.drawnBalls.push(ball);
  },
  [types.SET_DRAWN_BALLS](state, data) {
    state.drawnBalls = data;
  },
  [types.UPDATE_CONFIG](state, property) {
    const key = Object.keys(property)[0];
    const value = Object.values(property)[0];
    state.config[key] = value;
  },
  [types.SET_NEXT_GEN_CONFIG](state, config) {
    state.nextGenConfig = config.settings;
    window.igniteInstance = config.ignite;
  },
  [types.SET_NEXTGEN_STANDALONE_INTEGRATION](state, integration) {
    state.nextgenStandaloneIntegration = integration;
  },
};
